import React, { useEffect, useState } from 'react';
import './Personalization.scss';
import SubInfo, { SubInfoItem, SubInfoItemGroup } from '../SubInfo';
import { Link, withRouter } from 'react-router-dom';
import Section from '../Section/Section';
import TopInformation from '../TopInformation';
import Currency from '../Currency';
import Counter from '../Counter/Counter';
import Icon from '../Icon';
import bem from '../../utils/bem';
import useCar from '../../utils/hooks/useCar';
import { toFinanceFormatted } from '../../utils/helpers';
import useVersion from '../../utils/hooks/useVersion';
import VideoCallButton from '../VideoCallButton/VideoCallButton';

const RenderCuotaString = ({ selectedBank, currentVersion }) => {
  const { hasActivePromo } = useVersion();
  if (hasActivePromo) {
      return (
        <>
        Cuota aprox
        <span className="minicuotas">Minicuotas</span>
        </>
        
      )
  }
  return `Cuota aprox ${toFinanceFormatted(selectedBank?.post_type) || ''}`;
}

const CuotaAprox = ({ loading, currentVersion, selectedBank, cuota, isMobile }) => (
  !loading && currentVersion && (
    <SubInfoItemGroup
      className={`${isMobile ? 'mobile-inline-flex': ''} ${bem('cuota-aprox', {
        'has-bank': !selectedBank?.post_type
      })}`}
      groupType="price"
      title={<RenderCuotaString selectedBank={selectedBank} currentVersion={currentVersion} />}
      subTitle={<Counter value={cuota} />}
    />
  )
);

const Personalization = ({
  car,
  fetchVersionInfo,
  children,
  match,
  title,
  subTitle,
  carUrl,
  isLoading,
  isSummary,
  options,
  leftPanel,
  rightPanel,
  leftMobilePanel,
  className = ''
}) => {
  const [show, setShow] = useState(true);
  const { data } = car;
  const currentVersion = data || {};
  const {
    cuota,
    maintenacePrice,
    accsPrice,
    insurancePrice,
    finalPrice,
    selectedBank,
  } = useCar(currentVersion);

  useEffect(() => {
    const { version, tipo, modelo, anio } = match.params;

    const carCode = data?.codigo;
    if (carCode === version) return;
    fetchVersionInfo(tipo, modelo, version, anio);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const videoCallButton = (
    <>
      <div>
        <VideoCallButton text={'Video llamada'} isSummary={false}/>
      </div>
    </>
  );

  const hasColor = () => {
    const {
      params: { color },
    } = match;
    const colors = currentVersion?.colors || [];

    return colors.find(x => x.colorDesc.toLowerCase() === color?.toLowerCase());
  };

  const hasCar = () => {
    return currentVersion?.codigo;
  };

  //Variable booleana para ver si se activa el boton de video llamada o no 
  const videoCallOn = currentVersion?.videoCallOption === "1";


  const getImageUrl = () => {
    if (carUrl) return carUrl;
    const pickedColor = hasColor();
    if (pickedColor) {
      return pickedColor?.imageGrande;
    }
    return currentVersion?.imagenGrande;
  };

  const showAccsAndMain =
    accsPrice > 0 || maintenacePrice > 0 || insurancePrice > 0;
  
  let rows = 0;

  if (accsPrice > 0) {
    rows++;
  }
  if (maintenacePrice > 0) {
    rows++;
  }
  if (insurancePrice > 0) {
    rows++;
  }

  const loading = car?.isLoading;
  const isLoadingV = car?.isLoading || (!car.data && !car?.isLoading);
  return (
    <div
      className={`${className} gradient ${bem('personalization', {'is-summary': isSummary})}`}
      style={{ '--color': currentVersion?.colorCode }}
    >
      {/* <Subheader
        title={'Ármalo a tu manera'}
        subtitle={'¡Adelante… elegí el que querás y contáctanos !'}
      /> */}
      <div className={bem('personalization__subinfo', {
        'is-summary': isSummary,
        'is-open': !show,
        'two-rows': rows === 1 || rows === 2,
        'three-rows': rows >= 3
      })}>
        <SubInfo
          brandUrl={currentVersion?.logoUrl}
          isLoading={isLoading || car.isLoading}
        >
          <SubInfoItem color="white" type="image">
            {currentVersion?.logoUrl && !(isLoading || car.isLoading) && (
              <Link to="/">
                <img
                  src={currentVersion?.logoUrl}
                  className="top-information__brand-image"
                  alt=""
                />
              </Link>
            
          )}
          </SubInfoItem>
          <SubInfoItem isLoading={isLoadingV}>
            <SubInfoItemGroup
              onClick={() => setShow(!show)}
              className="main-title"
              title={
                <>
                  {currentVersion?.modelo}
                  <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                    <button
                      className={bem('mobile personalization__close-button', {
                        active: show,
                      })}
                      // onClick={() => setShow(!show)}
                    >
                      <Icon type="down-arrow" />
                    </button>
                  </div>
                  <CuotaAprox 
                    loading={loading}
                    currentVersion={currentVersion}
                    selectedBank={selectedBank}
                    cuota={cuota}
                    isMobile={true}
                  /> 
                </>
              }
            />
            {hasCar() && (
              <div
                className={bem('personalization__space-between', {
                  active: show,
                  'show-maintenances': showAccsAndMain,
                })}
              >
                <SubInfoItemGroup
                  groupType="price"
                  title={'Precio Regular'}
                  subTitle={<Currency value={currentVersion?.precioPublico} />}
                />
                <SubInfoItemGroup
                  groupType="price"
                  title={'Descuento'}
                  subTitle={
                    <Currency value={currentVersion?.descuentoPromocion} />
                  }
                />
                <SubInfoItemGroup
                  groupType="price"
                  title={'Precio promocional'}
                  subTitle={<Currency value={currentVersion?.precioOferta} />}
                />
                {showAccsAndMain && (
                <>
                  {maintenacePrice > 0 && (
                    <SubInfoItemGroup
                      groupType="price"
                      title={'Mantenimiento'}
                      subTitle={<Counter value={maintenacePrice} />}
                    />
                  )}
                  {accsPrice > 0 && (
                    <SubInfoItemGroup
                      groupType="price"
                      title={'Accesorios'}
                      subTitle={<Counter value={accsPrice} />}
                    />
                  )}
                  <SubInfoItemGroup
                    groupType="price"
                    title={'Precio'}
                    subTitle={<Counter value={finalPrice} />}
                  />
                  {insurancePrice > 0 && (
                    <SubInfoItemGroup
                      groupType="price"
                      title={'Seguro'}
                      subTitle={<Counter value={insurancePrice} />}
                    />
                  )}
                </>
                )}
                {/* */}
              </div>
            )}
            
          </SubInfoItem>
          <SubInfoItem color="white" className="desktop">
          <CuotaAprox 
            loading={loading}
            currentVersion={currentVersion}
            selectedBank={selectedBank}
            cuota={cuota}
          />
          </SubInfoItem>
        </SubInfo>
      </div>
      <Section>
        <TopInformation
          title={title}
          subtitle={subTitle}
          brandUrl={currentVersion?.logoUrl}
          isLoading={isLoading === true || car.isLoading}
          imageUrl={getImageUrl()}
          isSummary={isSummary}
          options={options}
          leftPanel={leftPanel}
          rightPanel={rightPanel}
          leftMobilePanel={leftMobilePanel}
          videoCallOn={videoCallOn}
          videoCallButton={videoCallButton}
          isVersionComponent={false}
        >
          {children}
        </TopInformation>
        {!isSummary && children}
      </Section>
    </div>
  );
};

export default withRouter(Personalization);
